;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="2df5bcd5-4c9d-4746-8949-472472ef75bc",e._sentryDebugIdIdentifier="sentry-dbid-2df5bcd5-4c9d-4746-8949-472472ef75bc")}catch(e){}}();import { useContext, useEffect } from 'react';
import AppContext from '../context/AppContext.js';
import '../_virtual/_sentry-release-injection-file.js';

const useHeaderVersion = () => {
    const { backendHeaderVersion } = useContext(AppContext);
    useEffect(() => {
        window.shopHeaderMetaData = {
            frontend: "3.32.0",
            backend: backendHeaderVersion,
        };
    }, []);
};

export { useHeaderVersion };
//# sourceMappingURL=useHeaderVersion.js.map
